import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators, AbstractControl } from '@angular/forms';
import { PlansService } from 'src/app/shared/services/plans.service'; 
import { UserService } from '../../shared/services/user.service';
import { ActivatedRoute } from '@angular/router';
import { Router } from '@angular/router';
@Component({
  selector: 'app-change-password',
  templateUrl: './change-password.component.html',
  styleUrls: ['./change-password.component.css']
})
export class ChangePasswordComponent implements OnInit {

  changePasswordForm!: FormGroup;
  submitted = false;
  showPassword = false;
  showConfirmPassword = false;

 constructor(
  private fb: FormBuilder,
  private plansService: PlansService,
  private userService: UserService,
  private route: ActivatedRoute,
  private router: Router
) {}


    region: string = 'IN';
    forgotPinSecretKey!: string;

  ngOnInit(): void {
    this.changePasswordForm = this.fb.group({
      password: ['', [Validators.required, Validators.minLength(6)]],
      confirm_password: ['', Validators.required]
    }, {
      validators: this.passwordMatchValidator
    });

    this.route.queryParams.subscribe(params => {
    this.forgotPinSecretKey = params['forgot_pin_secret_key'];
    console.log('forgot_pin_secret_key:', this.forgotPinSecretKey);
  });


      this.userService.autoRegion(this.region).subscribe(
      (resp) => {
        this.region = resp['region'].country_code2;
        window.localStorage.setItem('IPzip',JSON.stringify(resp.region))
         window.localStorage.setItem("region", this.region);
      });


  }

  passwordMatchValidator(control: AbstractControl) {
    const password = control.get('password')?.value;
    const confirmPassword = control.get('confirm_password')?.value;

    if (password && confirmPassword && password !== confirmPassword) {
      control.get('confirm_password')?.setErrors({ mismatch: true });
    } else {
      const errors = control.get('confirm_password')?.errors;
      if (errors) {
        delete errors['mismatch'];
        if (!Object.keys(errors).length) {
          control.get('confirm_password')?.setErrors(null);
        }
      }
    }
    return null;
  }

  get f() {
    return this.changePasswordForm.controls;
  }

  onSubmit() {
  this.submitted = true;

  if (this.changePasswordForm.invalid) {
    return;
  }

  const reset_params = {
        user: {
        key: this.forgotPinSecretKey,
        password: this.changePasswordForm.value.password,
        confirm_password: this.changePasswordForm.value.confirm_password,
        region : this.region,
        type: "email",
        }
      }
  this.plansService.changePassword(reset_params,this.region).subscribe({
    next: (res) => {
      console.log('Success:', res);
       this.router.navigate(['/']);
    },
    error: (err) => {
      console.error('Change password error:', err);
      alert('Error changing password: ' + err.error.error.message);
    }
  });
}

changePassword(payload: any) {
  console.log(payload);
  // API call
}


togglePassword() {
  this.showPassword = !this.showPassword;
}

toggleConfirmPassword() {
  this.showConfirmPassword = !this.showConfirmPassword;
}

}
